import { makeStyles } from 'tss-react/mui';
import { Alert, AlertTitle } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { alertIconMapping } from '@uplift/ui-v2';
import { CardDeclinedStatusType, CardExpirationStatusType } from '../../queries';


export type CardStatusInlineAlertType = {
  status: CardExpirationStatusType |  CardDeclinedStatusType;
};


export const CardStatusInlineAlert: React.VFC<CardStatusInlineAlertType> = ({ status }) => {
  const l10n = useL10n();
  const severity = status === 'expiresSoon' ? 'warning' : 'error';
  const { classes: alertClasses } = useAlertStyles();
  const { classes: alertTitleClasses } = useAlertTitleStyles({ severity });

  const titleMap = {
    declined: l10n.accountSettings.billing.declined,
    expiresSoon: l10n.accountSettings.billing.expiresSoon,
    expired: l10n.accountSettings.billing.expired,
  };

  const title = titleMap[status];

  // this component should only be rendered when status is not null, but here's an extra check
  if (!title || !status) return null;

  return (
    <Alert
      severity={severity}
      classes={alertClasses}
      iconMapping={alertIconMapping}
    >
      <AlertTitle
        classes={alertTitleClasses}
      >
        {title}
      </AlertTitle>
    </Alert>
  );
};

const useAlertStyles = makeStyles()((theme) => ({
  root: {
    background: 'transparent',
    padding: 0,
    display: 'flex',
    alignItems: 'center'
  },
  message: {
    padding: 0,
    height: 'fit-content',
  },
  icon: {
    marginTop: theme.spacing(-.5),
    padding: 0,
    marginRight: theme.spacing(.5),
  },
}));

type AlertTitleStylesProps = { severity: 'warning' | 'error' };
const useAlertTitleStyles = makeStyles<AlertTitleStylesProps>()((theme, { severity }) => ({
  root: {
    marginBottom: 0,
    color: theme.palette[severity].main,
    fontWeight: 700,
    textTransform: 'uppercase',
    fontSize: '12px',
    letterSpacing: '1px'
  }
}));
